import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

// import Import from '@/popup/components/views/Home/Settings/Profile/Import/Import.vue'
// import Backup from '@/popup/components/views/Home/Settings/Profile/Backup/Backup.vue'
// import RestoreBackup from '@/popup/components/views/Home/Settings/Profile/Backup/RestoreBackup.vue'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Disable device-to-device import until we redesign the UX\n    <Import /> "),
    _createCommentVNode(" TODO: Disabling backup until we had a chance to fix it.\n    <Backup />\n    <RestoreBackup />\n    ")
  ]))
}
}

})